import React, { useContext, useEffect, useState } from 'react'
import { apiGet } from '../../utils/apiFetch'
import apiPath from '../../utils/apiPath'
import Table from './Table'
import Pagination from '../Pagination'
import AuthContext from 'context/AuthContext'
import dayjs from 'dayjs'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { useTranslation } from 'react-i18next'
import TransactionView from './TransactionView'
import PropertyView from './PropertyView'
import AuctionView from './AuctionView'

function TransactionManager () {
  const { t } = useTranslation()
  const { logoutUser, user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'transaction_manager') ?? {}
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [viewAuctionModal, setViewAuctionModal] = useState(false)
  const [viewPropertyModal, setViewPropertyModal] = useState(false)
  const [viewShowModal, setViewShowModal] = useState(false)
  const [users, setAllUser] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')

  const [filterData, setFilterData] = useState({
    transactionType: '',
    searchkey: '',
    startDate: '',
    endDate: '',
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })

  const getAllUser = async data => {
    try {
      const { transactionType, startDate, endDate, searchkey, isFilter } =
        filterData
      if (
        (data?.deletePage && !(users?.length > 1)) ||
        (isFilter &&
          transactionType &&
          data?.statusChange &&
          !(users?.length > 1))
      ) {
        if (!(users?.length > 1)) {
          setPage(page - 1)
          // setIsDelete(true)
          setPaginationObj({ ...paginationObj, page: page - 1 })
        }
      } else {
        // setIsDelete(false)
      }
      const payload = {
        page,
        pageSize,
        transactionType,
        start_date: startDate ? dayjs(startDate).format('YYYY-MM-DD') : null,
        end_date: endDate ? dayjs(endDate).format('YYYY-MM-DD') : null,
        keyword: searchkey,
        sort_key: sort.sort_key,
        sort_type: sort.sort_type
      }

      const path = apiPath.getTransactions
      const result = await apiGet(path, payload)
      if (result?.status === 200) {
        const response = result?.data?.results
        const resultStatus = result?.data?.success
        setAllUser(response?.docs)
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null
        })
      }
    } catch (error) {
      console.log('error ', error)
      setPaginationObj({})
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handelEdit = item => {
    setItem(item)
    // setEditShowModal(true)
  }

  const handleUserView = item => {
    setItem(item)
    setViewShowModal(true)
  }
  const handleAuctionView = item => {
    setItem(item)
    setViewAuctionModal(true)
  }
  const handlePropertyView = item => {
    setItem(item)
    setViewPropertyModal(true)
  }

  useEffect(() => {
    getAllUser()
  }, [page, filterData, sort])

  const handleReset = () => {
    setFilterData({
      transactionType: '',
      searchkey: '',
      startDate: '',
      endDate: '',
      isReset: true,
      isFilter: false
    })
    setPage(1)
    // setIsDelete(true)
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
    // setIsDelete(true)
  }
  const statusPage = e => {
    setFilterData({
      ...filterData,
      transactionType: e.target.value,
      isFilter: true
    })
    setPage(1)
    // setIsDelete(true)
  }
  return (
    <div>
      <div className='bg-white'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] '>
            <form className='border-b border-b-[#E3E3E3] grid md:grid-cols-2 px-4 py-3 pt-5'>
              <div className='flex flex-wrap  items-center'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap justify-center'>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={filterData?.isReset}
                    setIsReset={setFilterData}
                  />
                  <div className='flex items-center mb-3 ml-3'>
                    <select
                      id='countries'
                      type=' password'
                      name='floating_password'
                      className='block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                      placeholder=' '
                      value={filterData?.transactionType}
                      onChange={e => statusPage(e)}
                    >
                      <option defaultValue value=''>
                        {t('O_ALL')}
                      </option>
                      <option value='biddingFees'>{t('O_BIDDING_FEES')}</option>
                      <option value='subscription'>
                        {t('O_SUBSCRIPTION')}
                      </option>
                    </select>
                  </div>
                  <button
                    type='button'
                    onClick={handleReset}
                    className='bg-[#8FC150] text-sm px-8 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-[#8FC150] sm:w-auto w-1/2'
                  >
                    {t('O_RESET')}
                  </button>
                </div>
              </div>
            </form>
            <Table
              users={users}
              user={user}
              getAllUser={getAllUser}
              handelEdit={handelEdit}
              handleUserView={handleUserView}
              handlePropertyView={handlePropertyView}
              handleAuctionView={handleAuctionView}
              page={page}
              setSort={setSort}
              sort={sort}
              manager={manager}
              paginationObj={paginationObj}
            />
            {paginationObj?.totalItems !== 0 && (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            )}
          </div>
        </div>
      </div>
      <>
        {viewShowModal && (
          <TransactionView setViewShowModal={setViewShowModal} item={item} />
        )}
        {viewPropertyModal && (
          <PropertyView
            setViewPropertyModal={setViewPropertyModal}
            item={item}
          />
        )}
        {viewAuctionModal && (
          <AuctionView setViewAuctionModal={setViewAuctionModal} item={item} />
        )}
      </>
    </div>
  )
}
export default TransactionManager
